import { useCallback } from "react"
import {
  useCompanyConnectorControllerGetGa4PropertiesQuery,
  useCompanyConnectorControllerSetGa4PropertyMutation,
} from "~/ui-rtk/api/companyConnectorApi"

export const useConnect = (companyConnectorId?: string) => {
  if (!companyConnectorId) {
    return {
      setProperty: async () =>
        Promise.reject(new Error("No company connector ID provided")),
      isLoading: false,
      properties: [],
      isLoadingProperties: false,
      propertiesError: null,
    }
  }

  const {
    data: propertiesData,
    isLoading: isLoadingProperties,
    error: propertiesError,
  } = useCompanyConnectorControllerGetGa4PropertiesQuery(
    { id: companyConnectorId },
    { skip: false },
  )

  const [setGa4PropertyAsync, { isLoading: isSettingProperty }] =
    useCompanyConnectorControllerSetGa4PropertyMutation()

  const properties = propertiesData?.data || []

  const setProperty = useCallback(
    async (companyConnectorId: string, propertyId: string) => {
      await setGa4PropertyAsync({
        id: companyConnectorId,
        setGa4PropertyDto: { propertyId },
      }).unwrap()
    },
    [setGa4PropertyAsync],
  )

  const isLoading = isSettingProperty

  return {
    setProperty,
    isLoading,
    properties,
    isLoadingProperties,
    propertiesError: propertiesError ? "Failed to load GA4 properties" : null,
  }
}
